// src/reporting/renderer/blocks/RepeatBlock.js
import React, { Fragment } from "react";
import { evalBinding } from "../../lib/bindings";
import { BlockRenderer } from "../../renderer/ReportRenderer";

export default function RepeatBlock({ block, data, template }: any) {
  const items = evalBinding(block.each, data) ?? [];
  if (!Array.isArray(items)) return null;

  return (
    <Fragment>
      {items.map((item: any, idx: number) => {
        // IMPORTANT:
        // - item is the repeated scope (e.g., a landman object)
        // - data is the original/root payload (company/client/header/etc.)
        //
        // We merge BOTH so expressions inside the repeat can still access:
        //   client, company, header, invoice, etc.
        // and ALSO can use $root explicitly if you prefer.
        const scoped = {
          ...data,        // root fields available directly (client/company/header...)
          ...item,        // repeated item fields override if same name
          $root: data,    // explicit root reference
          $index: idx,
          $item: item,
        };

        return (
          <div
            key={idx}
            className={block.itemClassName || ""}
            style={{ marginBottom: 24 }}
          >
            {block.blocks.map((b: any, i: number) => (
              <BlockRenderer key={i} block={b} data={scoped} template={template} />
            ))}
          </div>
        );
      })}
    </Fragment>
  );
}
